import { render, staticRenderFns } from "./HotBlockCard.vue?vue&type=template&id=dc571192&scoped=true"
import script from "./HotBlockCard.vue?vue&type=script&lang=ts"
export * from "./HotBlockCard.vue?vue&type=script&lang=ts"
import style0 from "./HotBlockCard.vue?vue&type=style&index=0&id=dc571192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc571192",
  null
  
)

export default component.exports